import styled from 'styled-components';
import photoHeader from 'assets/images/photo-header.jpg';
import { fonts } from 'styles';

export const Container = styled.header`
  width: 100%;
  height: 100vh;
  background: url(${photoHeader}) no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBold};
  font-size: 78px;
  line-height: 81px;
  color: #fff;
  text-align: center;
  margin-bottom: 40px;

  @media screen and (max-width: 500px) {
    font-size: 45px;
    line-height: 45px;
  }
`;

export const Description = styled.article`
  font-family: ${fonts.BentonSansMedium};
  font-size: 22px;
  line-height: 28px;
  text-align: center;
  width: 100%;
  max-width: 558px;
  margin-bottom: 40px;

  @media screen and (max-width: 500px) {
    font-size: 18px;
    line-height: 24px;
    max-width: 258px;
  }
`;

export const Credits = styled.article`
  font-size: 18px;
  text-align: center;

  span {
    font-family: ${fonts.BentonSansBold};
  }
`;
